import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import InputField from "../../components/form/inputField/inputField";
import InputCapitalField from "../../components/form/inputField/inputCapitalField";
import ErrorMsg from "../../components/form/errorMsg";
import {
  divisionEdit,
  DivisionDetail,
} from "../../redux/actions/divisionAction.js";
import { useDispatch } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import SuccessPopup from "../../components/popups/ChangeSaved";
import back from "../../assets/back.svg";
import { useNavigate } from "react-router-dom";
import { AdminButton } from "../../components/buttons/versionHistoryBtn";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import ErrorPopup from "../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../components/utilites/loader";

const DivisionEdit = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const [active, setActive] = useState("");
  const [reimbursementActive, setReimbursementActive] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [selectedDivisionData, setSelectedDivisionData] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(
      DivisionDetail(params.id, onDivisionViewSuccess, onDivsionViewError)
    );
  }, []);

  const onDivisionViewSuccess = (data) => {
    setSelectedDivisionData(data.data.data);
    setLoading(false);
    console.log(data);
  };

  const onDivsionViewError = (err) => {
    setLoading(false);
    console.log(err);
  };

  const initialValues = {
    division_id: selectedDivisionData?.id,
    name: selectedDivisionData?.name,
    offer_type: selectedDivisionData?.offer_type,
    order_limit: selectedDivisionData?.order_limit,
    order_amount: selectedDivisionData?.order_amount,
    reimbursement_method: selectedDivisionData?.reimbursement_method,
    approval_level: selectedDivisionData?.approval_level
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    offer_type: Yup.string().required("Required"),
    reimbursement_method: Yup.string().required("Required"),
    order_amount: Yup.string().required("Required"),
    approval_level: Yup.string().required("Required")
  });

  const resetFunc = (setFieldValue) => {
    setFieldValue("name", selectedDivisionData?.name);
    setFieldValue("offer_type", selectedDivisionData?.offer_type);
    setFieldValue("order_limit", selectedDivisionData?.order_limit);
    setFieldValue("order_amount", selectedDivisionData?.order_amount);
    setFieldValue("reimbursement_method", selectedDivisionData?.reimbursement_method);
    setFieldValue("approval_level", selectedDivisionData?.approval_level);
  };

  const onSubmit = (values) => {
    console.log(values);
    values["vendor_id"] = selectedDivisionData?.id;
    values["division_id"] = params?.id;
    dispatch(divisionEdit(values, onAddSuccess, onAddError));
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    navigate("/division");
  };

  const onAddSuccess = (data) => {
    console.log(data);
    setSelectedDivisionData(data.data.data);
    setShowSuccessPopup(true);
    const msg = data.data.message;
    const modified_msg = msg.charAt(0).toUpperCase() + msg.slice(1);
    setShowSuccessMsg(modified_msg);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };
  const onAddError = (err) => {
    setShowErrorPopup(true);
    setShowErrorMsg(err.data.message);
    console.log(err);
  };

  const options = [
    { value: "quantity", label: "Quantity" },
    { value: "price", label: "Price" },
    { value: "discount", label: "Discount" },
  ];

  const approvalOptions = [
    { value: "L1", label: "LEVEL 1" },
    { value: "L2", label: "LEVEL 2" },
    { value: "L3", label: "LEVEL 3" },
    { value: "L4", label: "LEVEL 4" },
    { value: "L5", label: "LEVEL 5" },
    { value: "L6", label: "LEVEL 6" },
    { value: "L7", label: "LEVEL 7" },
    { value: "L8", label: "LEVEL 8" },
    { value: "L9", label: "LEVEL 9" },
    { value: "L10", label: "LEVEL 10" },
    { value: "L11", label: "LEVEL 11" },
    { value: "L12", label: "LEVEL 12" },
    { value: "L13", label: "LEVEL 13" },
    { value: "L14", label: "LEVEL 14" },
    { value: "L15", label: "LEVEL 15" },
    { value: "admin", label: "ADMIN" },
  ];

  const reimbursementOptions = [
    { value: "forward_cfa", label: "Full Order Forward from CFA" },
    { value: "order_off_qty", label: "Order Offer Quantity" },
    { value: "full_order_qty", label: "Full Order Quantity" },
    { value: "credit_note", label: "Credit Note for Offer" }
  ];

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/division",
      breadcrumb: " / division",
    },
    {
      path: "/division/edit",
      breadcrumb: " / edit",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <>
      <div className="products-page">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className="header-route-page fw_400 cursor_pointer"
              >
                <span className="fs_18">{breadcrumb}</span>
              </NavLink>
            ))}
          </div>
          <div className="products-main-list my-2 py-1">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              enableReinitialize={true}
            >
              {({ errors, setFieldValue, values }) => (
                <Form>
                  <div className="search-container d-flex justify-content-between">
                    <div
                      className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                      onClick={() => navigate(-1)}
                    >
                      <img src={back} alt="back_btn" />
                      <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                        BACK
                      </span>
                    </div>
                    <div className=" d-flex justify-content-between m-1 mb-2">
                      <AdminButton
                        background="#E7E5FF"
                        width="100px"
                        type="button"
                        onClick={() => resetFunc(setFieldValue)}
                      >
                        RESET
                      </AdminButton>
                      <AdminButton
                        background="#7065e4"
                        color="white"
                        width="100px"
                        type="submit"
                      >
                        <span className="m-2">SAVE</span>
                      </AdminButton>
                    </div>
                  </div>
                  <div style={{ position: "relative" }}>
                    {loading == true ? (
                      <div className="list-spinner-container">
                        <LoadingSpinnerTable />
                      </div>
                    ) : (
                      <div className="scrolling">
                        <div className="form-width ms-4 ps-3 py-1">
                          <div className="my-2">
                            <label className="color_747f9e fw_400 fs_14 my-1">
                              Division ID
                            </label>
                            <p className="fs_16">
                              {selectedDivisionData?.code
                                ? selectedDivisionData?.code
                                : "--"}
                            </p>
                          </div>
                        </div>
                        <div className="form-width ms-4 ps-3 py-1">
                          <div className="my-2">
                            <InputCapitalField
                              setFieldValue={setFieldValue}
                              id={"name"}
                              label={"Division Name"}
                              labelColor="color_747f9e"
                              type={"text"}
                              placeholder={"Enter your division name"}
                              name={"name"}
                              value={values?.name}
                            />
                            <div className="select-container">
                              <label className="w-100 mx-1 fn_Nunito fs_14 color_747f9e">
                                Offer Type
                              </label>
                              <Field name={"offer_type"}>
                                {({ field, meta }) => (
                                  <Select
                                    {...field}
                                    options={options}
                                    styles={customStyles}
                                    placeholder={"Select Offer type"}
                                    value={options.filter(
                                      (s) => s.value == values?.offer_type
                                    )}
                                    onChange={(selected) => {
                                      setFieldValue(
                                        "offer_type",
                                        selected?.value
                                      );
                                    }}
                                  />
                                )}
                              </Field>
                              <ErrorMsg name="offer_type" />
                            </div>
                            <div className="select-container">
                              <label className="w-100 mx-1 fn_Nunito fs_14 color_747f9e">
                                Approval Level
                              </label>
                              <Field name={"approval_level"}>
                                {({ field, meta }) => (
                                  <Select
                                    {...field}
                                    options={approvalOptions}
                                    styles={customStyles}
                                    placeholder={"Select Approval Level"}
                                    value={approvalOptions.filter(
                                      (s) => s.value == values?.approval_level
                                    )}
                                    onChange={(selected) => {
                                      setFieldValue(
                                        "approval_level",
                                        selected?.value
                                      );
                                    }}
                                  />
                                )}
                              </Field>
                              <ErrorMsg name="approval_level" />
                            </div>
                            <div className="my-2">
                              <label className="color_747f9e">
                                Reimbursement method
                              </label>
                              <div>
                                {reimbursementOptions?.map((ele, index) => (
                                  <div
                                    className="d-flex align-items-start my-2"
                                    key={index}
                                  >
                                    <span className="fs_14 my-1">
                                      <Field
                                        type="radio"
                                        className="radio me-1"
                                        value={ele.value}
                                        name="reimbursement_method"
                                        onClick={() => {
                                          setReimbursementActive(ele.value);
                                        }}
                                      />
                                    </span>
                                    <label className={
                                      reimbursementActive === ele.value
                                        ? "color_262c3d mx-1 mt-1"
                                        : "color_747f9e mx-1 mt-1"
                                    } >{ele.label}</label>
                                  </div>
                                ))}
                                <ErrorMsg name={"reimbursement_method"} />
                              </div>
                            </div>
                            <div className="my-2">
                              <label className="color_747f9e">
                                Order limit per customer
                              </label>
                              <div className="d-flex gap-2">
                                <div className="d-flex align-items-center ">
                                  <Field
                                    className="radio me-2"
                                    type="radio"
                                    id="Weekly"
                                    name="order_limit"
                                    value="weekly"
                                    onClick={() => {
                                      setActive("Weekly");
                                    }}
                                  />
                                  <label
                                    for="Weekly"
                                    className={
                                      active === "Weekly"
                                        ? "color_262c3d"
                                        : "color_747f9e"
                                    }
                                  >
                                    Weekly
                                  </label>
                                </div>
                                <div className="d-flex align-items-center ">
                                  <Field
                                    className="radio mx-2"
                                    type="radio"
                                    id="Monthly"
                                    name="order_limit"
                                    value="monthly"
                                    onClick={() => {
                                      setActive("Monthly");
                                    }}
                                  />
                                  <label
                                    for="Monthly"
                                    className={
                                      active === "Monthly"
                                        ? "color_262c3d"
                                        : "color_747f9e"
                                    }
                                  >
                                    Monthly
                                  </label>
                                </div>
                                <div className="d-flex align-items-center ">
                                  <Field
                                    className="radio mx-2"
                                    type="radio"
                                    id="Quarterly"
                                    name="order_limit"
                                    value="quarterly"
                                    onClick={() => {
                                      setActive("Quarterly");
                                    }}
                                  />
                                  <label
                                    for="Quarterly"
                                    className={
                                      active === "Quarterly"
                                        ? "color_262c3d"
                                        : "color_747f9e"
                                    }
                                  >
                                    Quarterly
                                  </label>
                                </div>
                              </div>
                              <ErrorMsg name={"order_limit"} />
                              <InputField
                                id={"order_amount"}
                                labelColor="color_262c3d"
                                type={"text"}
                                placeholder={"Enter Order Amount"}
                                name={"order_amount"}
                                value={values?.order_amount}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Form>
              )}
            </Formik>
            <SuccessPopup show={showSuccessPopup} title={showSuccessMsg} />
            <ErrorPopup
              show={showErrorPopup}
              title={showErrorMsg}
              handleClose={closeErrorPopup}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default DivisionEdit;

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    maxWidth: "450px",
    height: "40px",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",

    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
